import type { LotDelivery } from '../api/types.js';
import { formatDateTime } from '../lib/format.js';
import { Badge } from './badge.js';

export function DeliveriesTable({ deliveries }: { deliveries: LotDelivery[] }) {
  if (deliveries.length === 0) {
    return <p className="text-sm text-muted-foreground">Sin entregas a clientes registradas.</p>;
  }
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left">
        <caption className="sr-only">
          Entregas a clientes del lote y de los lotes generados a partir de él
        </caption>
        <thead className="border-b border-border text-sm text-muted-foreground">
          <tr>
            <th scope="col" className="py-2 pr-4 font-medium">
              Cliente
            </th>
            <th scope="col" className="py-2 pr-4 font-medium">
              Pedido
            </th>
            <th scope="col" className="py-2 pr-4 font-medium">
              Lote entregado
            </th>
            <th scope="col" className="py-2 pr-4 font-medium">
              Fecha
            </th>
            <th scope="col" className="py-2 pr-4 font-medium">
              Estado
            </th>
            <th scope="col" className="py-2 text-right font-medium">
              Unidades
            </th>
          </tr>
        </thead>
        <tbody>
          {deliveries.map((delivery) => (
            <tr
              key={`${delivery.lotId}-${delivery.orderReference}`}
              className="border-b border-border/60"
            >
              <td className="py-2 pr-4">{delivery.customerName}</td>
              <td className="py-2 pr-4 break-all">{delivery.orderReference}</td>
              <td className="py-2 pr-4 break-all">
                {delivery.lotId} {delivery.isDirect ? '' : '(indirecta)'}
              </td>
              <td className="py-2 pr-4">{formatDateTime(delivery.dispatchedAt)}</td>
              <td className="py-2 pr-4">
                {delivery.status === 'DISPATCHED' ? (
                  <Badge tone="success">Despachado</Badge>
                ) : (
                  <Badge tone="warning">Vendido, pendiente de despacho físico</Badge>
                )}
              </td>
              <td className="py-2 text-right font-medium">{delivery.quantity}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
